export const tabsData:string = `
    {
    exploreProductList {
      id
      name
      grId: slug
    }
  }
`;

const fetchData = (pageId: number, id:string): string => `
    {
        exploreContentByInterests(product: "${id}") {
          id
          title
          type
          uri
          link
          description
          date
        }
        
        page(id: "${pageId}", idType: DATABASE_ID) {
            PostLoginPage {
              exploreSliderTitle
              exploreSliderDescription
            }
      }
  }
`;
export default fetchData;
